const BoughtWith = function () {
    const _handleBoughtWithCarousel = function (product, isPlpBool) {
        let productInBoughtWithCarrousel = product.closest('#frequently-bought-together').length;
        let productInUpSellContainer = product.closest('.product-upSell-container').length;
        if (typeof boughtWithFromAddToCartEnabled !== 'undefined' && boughtWithFromAddToCartEnabled && !productInBoughtWithCarrousel && !productInUpSellContainer) {
            _loadBoughtWithFragment(product, isPlpBool);
        }
    };

    const _loadBoughtWithFragment = function (productTile, isPlpBool) {
        if (typeof boughtWithProductsSuffixURL !== 'undefined' && boughtWithProductsSuffixURL !== null) {
            let sku = productTile.closest('.default-product-tile').data('product-code');
            let baseUrl = lang == 'en' ? '/en/' : '/';
            let boughtWithUrl = baseUrl + sku + boughtWithProductsSuffixURL;

            let dataListNameOrigin;
            if (window.location.pathname === homePageUrl || window.location.pathname === alternateHomePageFrUrl) {
                dataListNameOrigin = "homeSuggestions";
            }
            closeUpSellPanel();
            $.ajax({
                url: boughtWithUrl,
                type: 'GET',
                success: function (data, code, jqXHR) {
                    if (jqXHR.getResponseHeader('hasBoughtWithProduct') === 'true') {
                        upSellDisplay.displayUpsellSlide(data, productTile, dataListNameOrigin, false, isPlpBool);
                    }
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });
        }
    };
    return {
        handleBoughtWithCarousel: _handleBoughtWithCarousel,
        loadBoughtWithFragment: _loadBoughtWithFragment
    };
}();